/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/lease_transactions-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/lease_transactions-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/lease_transactions-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-lease_transactions-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/lease_transactions.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/lease_transactions-entity-config.ts
 * Public fields: 49/49 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const LeaseTransactionsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  transaction_type_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // transaction_type_id field
  transaction_status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // transaction_status_id field
  source_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // source_id field
  external_ref: Type.Union([Type.String(), Type.Null()]), // external_ref field
  lease_name: Type.Union([Type.String(), Type.Null()]), // lease_name field
  leased_sf: Type.Union([Type.Number(), Type.Null()]), // leased_sf field
  asking_rate: Type.Union([Type.Number(), Type.Null()]), // asking_rate field
  effective_rate: Type.Union([Type.Number(), Type.Null()]), // effective_rate field
  term_months: Type.Union([Type.Number(), Type.Null()]), // term_months field
  term_days: Type.Union([Type.Number(), Type.Null()]), // term_days field
  execution_date: Type.Union([Type.String(), Type.Null()]), // execution_date field
  commencement_date: Type.Union([Type.String(), Type.Null()]), // commencement_date field
  expiration_date: Type.Union([Type.String(), Type.Null()]), // expiration_date field
  free_rent: Type.Union([Type.Number(), Type.Null()]), // free_rent field
  ti_allowance: Type.Union([Type.Number(), Type.Null()]), // ti_allowance field
  escalation_notes: Type.Union([Type.String(), Type.Null()]), // escalation_notes field
  comments: Type.Union([Type.String(), Type.Null()]), // comments field
  verified_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // verified_at field
  verified_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // verified_by_user_profile_id field
  created_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // created_by_user_profile_id field
  updated_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // updated_by_user_profile_id field
  created_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // created_at field
  updated_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // updated_at field
  permission_level_id: Type.String({ format: "uuid" }), // permission_level_id field
  is_colliers_lease: Type.Boolean(), // is_colliers_lease field
  external_key: Type.Union([Type.String(), Type.Null()]), // external_key field
  review_status_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // review_status_id field
  reviewed_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // reviewed_at field
  reviewed_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // reviewed_by_user_profile_id field
  free_rent_type: Type.Union([Type.String(), Type.Null()]), // free_rent_type field
  ti_type: Type.Union([Type.String(), Type.Null()]), // ti_type field
  avg_escalation: Type.Union([Type.Number(), Type.Null()]), // avg_escalation field
  total_deal_value: Type.Union([Type.Number(), Type.Null()]), // total_deal_value field
  created_by_ingestion_job_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // created_by_ingestion_job_id field
  free_rent_notes: Type.Union([Type.String(), Type.Null()]), // free_rent_notes field
  ti_notes: Type.Union([Type.String(), Type.Null()]), // ti_notes field
  lease_subtype_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // lease_subtype_id field
  rent_structure_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // rent_structure_id field
  internal_ref: Type.Union([Type.String(), Type.Null()]), // internal_ref field
  is_investment: Type.Union([Type.Boolean(), Type.Null()]), // is_investment field
  archived_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // archived_at field
  archived_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // archived_by_user_profile_id field
  archive_reason: Type.Union([Type.String(), Type.Null()]), // archive_reason field
  archive_batch_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // archive_batch_id field
  free_rent_amount: Type.Union([Type.Number(), Type.Null()]), // free_rent_amount field
  free_rent_months: Type.Union([Type.Number(), Type.Null()]), // free_rent_months field
  ti_amount: Type.Union([Type.Number(), Type.Null()]), // ti_amount field
  ti_months: Type.Union([Type.Number(), Type.Null()]), // ti_months field
});

export const CreateLeaseTransactionsSchema = Type.Object({
  transaction_type_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // transaction_type_id field
  transaction_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // transaction_status_id field
  source_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // source_id field
  external_ref: Type.Optional(Type.Union([Type.String(), Type.Null()])), // external_ref field
  lease_name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // lease_name field
  leased_sf: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // leased_sf field
  asking_rate: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // asking_rate field
  effective_rate: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // effective_rate field
  term_months: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // term_months field
  term_days: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // term_days field
  execution_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // execution_date field
  commencement_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // commencement_date field
  expiration_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // expiration_date field
  free_rent: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // free_rent field
  ti_allowance: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // ti_allowance field
  escalation_notes: Type.Optional(Type.Union([Type.String(), Type.Null()])), // escalation_notes field
  comments: Type.Optional(Type.Union([Type.String(), Type.Null()])), // comments field
  verified_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // verified_at field
  verified_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // verified_by_user_profile_id field
  created_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_user_profile_id field
  updated_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // updated_by_user_profile_id field
  permission_level_id: Type.Optional(Type.String({ format: "uuid" })), // permission_level_id field
  is_colliers_lease: Type.Optional(Type.Boolean()), // is_colliers_lease field
  external_key: Type.Optional(Type.Union([Type.String(), Type.Null()])), // external_key field
  review_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // review_status_id field
  reviewed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // reviewed_at field
  reviewed_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // reviewed_by_user_profile_id field
  free_rent_type: Type.Optional(Type.Union([Type.String(), Type.Null()])), // free_rent_type field
  ti_type: Type.Optional(Type.Union([Type.String(), Type.Null()])), // ti_type field
  avg_escalation: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // avg_escalation field
  total_deal_value: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // total_deal_value field
  created_by_ingestion_job_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_ingestion_job_id field
  free_rent_notes: Type.Optional(Type.Union([Type.String(), Type.Null()])), // free_rent_notes field
  ti_notes: Type.Optional(Type.Union([Type.String(), Type.Null()])), // ti_notes field
  lease_subtype_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // lease_subtype_id field
  rent_structure_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // rent_structure_id field
  internal_ref: Type.Optional(Type.Union([Type.String(), Type.Null()])), // internal_ref field
  is_investment: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])), // is_investment field
  free_rent_amount: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // free_rent_amount field
  free_rent_months: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // free_rent_months field
  ti_amount: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // ti_amount field
  ti_months: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // ti_months field
});

export const UpdateLeaseTransactionsSchema = Type.Object({
  transaction_type_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // transaction_type_id field
  transaction_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // transaction_status_id field
  source_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // source_id field
  external_ref: Type.Optional(Type.Union([Type.String(), Type.Null()])), // external_ref field
  lease_name: Type.Optional(Type.Union([Type.String(), Type.Null()])), // lease_name field
  leased_sf: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // leased_sf field
  asking_rate: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // asking_rate field
  effective_rate: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // effective_rate field
  term_months: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // term_months field
  term_days: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // term_days field
  execution_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // execution_date field
  commencement_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // commencement_date field
  expiration_date: Type.Optional(Type.Union([Type.String(), Type.Null()])), // expiration_date field
  free_rent: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // free_rent field
  ti_allowance: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // ti_allowance field
  escalation_notes: Type.Optional(Type.Union([Type.String(), Type.Null()])), // escalation_notes field
  comments: Type.Optional(Type.Union([Type.String(), Type.Null()])), // comments field
  verified_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // verified_at field
  verified_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // verified_by_user_profile_id field
  created_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_user_profile_id field
  updated_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // updated_by_user_profile_id field
  permission_level_id: Type.Optional(Type.String({ format: "uuid" })), // permission_level_id field
  is_colliers_lease: Type.Optional(Type.Boolean()), // is_colliers_lease field
  external_key: Type.Optional(Type.Union([Type.String(), Type.Null()])), // external_key field
  review_status_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // review_status_id field
  reviewed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // reviewed_at field
  reviewed_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // reviewed_by_user_profile_id field
  free_rent_type: Type.Optional(Type.Union([Type.String(), Type.Null()])), // free_rent_type field
  ti_type: Type.Optional(Type.Union([Type.String(), Type.Null()])), // ti_type field
  avg_escalation: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // avg_escalation field
  total_deal_value: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // total_deal_value field
  created_by_ingestion_job_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // created_by_ingestion_job_id field
  free_rent_notes: Type.Optional(Type.Union([Type.String(), Type.Null()])), // free_rent_notes field
  ti_notes: Type.Optional(Type.Union([Type.String(), Type.Null()])), // ti_notes field
  lease_subtype_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // lease_subtype_id field
  rent_structure_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // rent_structure_id field
  internal_ref: Type.Optional(Type.Union([Type.String(), Type.Null()])), // internal_ref field
  is_investment: Type.Optional(Type.Union([Type.Boolean(), Type.Null()])), // is_investment field
  free_rent_amount: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // free_rent_amount field
  free_rent_months: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // free_rent_months field
  ti_amount: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // ti_amount field
  ti_months: Type.Optional(Type.Union([Type.Number(), Type.Null()])), // ti_months field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type LeaseTransactionsRow = Static<typeof LeaseTransactionsSchema>;
export type LeaseTransactionsInsert = Static<typeof CreateLeaseTransactionsSchema>;
export type LeaseTransactionsUpdate = Static<typeof UpdateLeaseTransactionsSchema>;

// Legacy type aliases for backward compatibility
export type LeaseTransactions = LeaseTransactionsRow;
export type CreateLeaseTransactions = LeaseTransactionsInsert;
export type UpdateLeaseTransactions = Static<typeof UpdateLeaseTransactionsSchema>;

// Field configuration metadata
export const LeaseTransactionsFieldConfig = {
  filterable: ['id', 'transaction_type_id', 'transaction_status_id', 'source_id', 'verified_by_user_profile_id', 'created_by_user_profile_id', 'updated_by_user_profile_id', 'permission_level_id', 'review_status_id', 'reviewed_by_user_profile_id', 'created_by_ingestion_job_id', 'lease_subtype_id', 'rent_structure_id', 'archived_by_user_profile_id', 'archive_batch_id'] as const,
  sortable: ['execution_date', 'commencement_date', 'expiration_date', 'created_at', 'updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'permission_level_id', 'is_colliers_lease'] as const,
  readonly: ['id', 'created_at', 'updated_at', 'archived_at', 'archived_by_user_profile_id', 'archive_reason', 'archive_batch_id'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface LeaseTransactionsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface LeaseTransactionsResponse {
  data: LeaseTransactions[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleLeaseTransactionsResponse {
  data: LeaseTransactions | null;
  error: Error | null;
}
